/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var O;!function(O){O[O.NONE=0]="NONE",O[O.ZOOM=1]="ZOOM",O[O.TUMBLE=2]="TUMBLE",O[O.LOOK_AROUND=3]="LOOK_AROUND",O[O.PAN=4]="PAN",O[O.ASCEND=5]="ASCEND"}(O||(O={}));export{O as InteractionType};
